import { MenuItem, Select, Typography } from "@mui/material";
import React, { useContext } from "react";
import { makeStyles } from '@mui/styles';
import { PosContext } from "../shared/PosContext";
import {
    useUpdateuserDefaults
} from "../shared/hooks/useUser";

const useStyles = makeStyles(() => ({
    roomName: {
        fontStyle: 'normal',
        fontWeight: '700',
        fontSize: '14px',
        lineHeight: '17px',
        textTransform: 'uppercase',
        color: '#271D1C',
        whiteSpace: 'nowrap',
    },
}));

const SimpleFloorRooms = () => {
    const classes = useStyles();
    const { floorRooms, roomContext, refetchDefaultRoom } =
        useContext(PosContext);
    const [selectedRoom, setSelectedRoom] = roomContext;

    const updateuserDefaultsMutation = useUpdateuserDefaults();

    const handleRoomChange = (e, room) => {
        if (room) {
            setSelectedRoom(room.props.value);
            updateuserDefaultsMutation.mutate(
                {
                    key: "Room",
                    value: room.props.value.name,
                },
                {
                    onSuccess: () => {
                        refetchDefaultRoom();
                    },
                }
            );
        }
    };

    const roomKeys = floorRooms ? Object.keys(floorRooms) : [];
    const roomCount = roomKeys.length;

    return (
        <React.Fragment>
            {floorRooms && (
                <>
                    {roomCount === 1 ? (
                        <></>
                        // <Typography className={classes.roomName}>
                            // {/* {roomKeys[0]} */}
                        // </Typography>
                    ) : (
                        // Multiple rooms - show selector
                        <Select
                            labelId="rooms-select-standard-label"
                            value={selectedRoom || []}
                            variant="standard"
                            onChange={handleRoomChange}
                            label={"Room"}
                        >
                            {roomKeys.map((room, index) => (
                                <MenuItem
                                    value={floorRooms[room]}
                                    key={"Room_Item_" + index}
                                >
                                    {room}
                                </MenuItem>
                            ))}
                        </Select>
                    )}
                </>
            )}
        </React.Fragment>
    );
};

export default SimpleFloorRooms;
